import { Base } from "../../../base/components/base"
import { Input } from "../../../base/components/native/input"
import { baseStyle } from "./check.style"

export const Check = (title: string) => {
    const base = Base()
    base.cssClass(baseStyle)

    const isHiddenQuantities = Input(title, 'checkbox')
    isHiddenQuantities.el.name = '_check'
    const label = Base('label')
    label.el.htmlFor = '_check'
    label.el.textContent = title
    base.append(isHiddenQuantities, label)

    return Object.assign(base, {
        getValue: () => (isHiddenQuantities.el as HTMLInputElement).checked,
        setValue: (value: boolean) => {
            (isHiddenQuantities.el as HTMLInputElement).checked = value
        }
    })
}